import script from "./productList.vue?vue&type=script&setup=true&lang=js"
export * from "./productList.vue?vue&type=script&setup=true&lang=js"

import "./productList.vue?vue&type=style&index=0&id=90a2e354&scoped=true&lang=less"
import "./productList.vue?vue&type=style&index=1&id=90a2e354&lang=postcss"

import exportComponent from "/data/jenkins/workspace/DLJY-Web-Test/example/main/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-90a2e354"]])

export default __exports__